import SitesPopover from "../components/UI/Popovers/SitesPopover/SitesPopover";
import { createGuid } from "./CommonUtils";
import { getSiteFromSiteId, getUserTypeFromUserTypeId } from "./UsersUtils";

// parking locations avatars
export const getTokenParkingLocations = (params) => {
  let parkingLocations = null;
  let sites = [params.row.token.site]; // sitesPopover receives array
  if (sites) {
    return (parkingLocations = <SitesPopover sites={sites}></SitesPopover>);
  }

  return parkingLocations;
};

// finds the commonTokens from all carUserTokens
// by implementing a group by concept
export const getCommonTokens = (key, array, count) => {
  // groups property by key - example: tokenId
  let groupedResult = array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

  // represents the group by count
  // example: count = 1 - find all tokens that are common between users
  let groupedByCount = [];
  for (let key in groupedResult) {
    if (groupedResult[key].length > count) {
      groupedByCount.push(groupedResult[key]);
    }
  }

  return groupedByCount;
};

export const getAddedParkerToAllocationModel = (parker, commonData, carUserTokenData, sites = null, userTypes = null) => {
  // if site and userTypes available, will be populated
  let token = commonData?.token;
  let userType = commonData?.userType;

  let dataCopy = { ...commonData };
  let dataTokenCopy = { ...commonData.token };

  if (sites !== null) {
    let site = getSiteFromSiteId(sites, commonData?.token?.siteId);
    
    // populates site with site obj
    dataTokenCopy.site = site;
    dataCopy.token = dataTokenCopy;
    token = dataCopy.token;
  }

  if (userTypes !== null) {
    let localUserType = getUserTypeFromUserTypeId(userTypes, commonData?.token?.userTypeId);

    // populates userType with userType obj
    dataTokenCopy.userType = localUserType;
    dataCopy.userType = dataTokenCopy;
    userType = dataCopy.userType;
  }
  
  return {
    id: createGuid(), 
    token: token, 
    tokenId: dataCopy.token.id, 
    userType: userType,
    userId: parker?.utronUser.id, 
    fob: carUserTokenData?.fob, 
    isActive: carUserTokenData?.isActive, 
    isOccupied: carUserTokenData?.isOccupied, 
    carId: carUserTokenData?.carId, 
    parker: parker
  };
};
